class AssetSizeError extends Error {
  constructor(file: File, maxSize: number) {
    super(
      `The file ${file.name} exceeds the size limit of ${
        maxSize / 1000 / 1024
      }MB`
    );

    this.name = "AssetSizeError";
  }
}

export default AssetSizeError;
